/**
 * True for getDisplayMedia tracks (screen / window / browser share).
 * Webcam tracks from getUserMedia do not expose displaySurface.
 */
export const isDisplayMediaTrack = (track: MediaStreamTrack | undefined): boolean => {
  if (!track || track.kind !== 'video') {
    return false
  }

  return Boolean(track.getSettings?.()?.displaySurface)
}
